import router from "@/router/router";

export interface RouteInfo {
    name: string;
    path: string;
    fullPath: string;
}

/**
 * Extrae todas las rutas del router de forma recursiva
 */
export class RouterService {
    /**
     * Obtiene todas las rutas disponibles en el router
     */
    public static getAllRoutes(): RouteInfo[] {
        const routes: RouteInfo[] = [];

        // Usar any para acceder a options (existe en runtime pero no en tipos de Vue Router 3)
        const routerInstance = router as any;

        if (!routerInstance || !routerInstance.options || !routerInstance.options.routes) {
            return routes;
        }

        // Función recursiva para procesar rutas y sus hijos
        const processRoutes = (routeList: any[], parentPath: string = "") => {
            routeList.forEach((route) => {
                // Construir el path completo
                let currentPath = route.path;

                // Si el path no empieza con /, concatenar con el padre
                if (currentPath && !currentPath.startsWith("/")) {
                    currentPath = parentPath ? `${parentPath}/${currentPath}` : `/${currentPath}`;
                } else if (!currentPath) {
                    currentPath = parentPath;
                }

                // Solo agregar rutas que tengan un nombre y no sean redirects
                if (route.name && !route.redirect && currentPath) {
                    // Limpiar paths duplicados de barras
                    let cleanPath = currentPath.replace(/\/+/g, "/");

                    // Convertir parámetros de :param a {param} para que sean más claros
                    cleanPath = cleanPath.replace(/:(\w+)/g, "{$1}");

                    routes.push({
                        name: route.name,
                        path: route.path,
                        fullPath: cleanPath,
                    });
                }

                // Procesar rutas hijas recursivamente
                if (route.children && route.children.length > 0) {
                    processRoutes(route.children, currentPath);
                }
            });
        };

        processRoutes(routerInstance.options.routes);

        // Ordenar por fullPath
        return routes.sort((a, b) => a.fullPath.localeCompare(b.fullPath));
    }

    /**
     * Formatea el nombre de una ruta para mostrar
     */
    public static formatRouteName(name: string): string {
        return name
            .replace(/_/g, " ")
            .replace(/([A-Z])/g, " $1")
            .trim()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    }
}
